import { render, staticRenderFns } from "./Readme.vue?vue&type=template&id=cd7055a2&scoped=true"
import script from "./Readme.vue?vue&type=script&lang=js"
export * from "./Readme.vue?vue&type=script&lang=js"
import style0 from "./Readme.vue?vue&type=style&index=0&id=cd7055a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7055a2",
  null
  
)

export default component.exports